"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _propTypes = require("prop-types");

var _colors = _interopRequireDefault(require("../../../constants/colors"));

var _spacing = _interopRequireDefault(require("../../../constants/spacing"));

var _Tick = _interopRequireDefault(require("../../Icons/Tick"));

var _Error = _interopRequireDefault(require("../../Icons/Error"));

var _breakpoints = _interopRequireDefault(require("../../../constants/breakpoints"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; if (obj != null) { var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _templateObject9() {
  var data = _taggedTemplateLiteralLoose(["\n\tcolor: ", ";\n\tfont-size: 14px;\n"]);

  _templateObject9 = function _templateObject9() {
    return data;
  };

  return data;
}

function _templateObject8() {
  var data = _taggedTemplateLiteralLoose(["\n\tfont-weight: bold;\n\tword-break: break-all;\n"]);

  _templateObject8 = function _templateObject8() {
    return data;
  };

  return data;
}

function _templateObject7() {
  var data = _taggedTemplateLiteralLoose(["\n\tmargin: auto;\n"]);

  _templateObject7 = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6() {
  var data = _taggedTemplateLiteralLoose(["\n\tmargin: auto;\n"]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = _taggedTemplateLiteralLoose(["\n\tdisplay: flex;\n\tjustify-content: center;\n\talign-items: center;\n\tposition: absolute;\n\tpadding: 6px;\n\theight: 22px;\n\twidth: 22px;\n\ttop: -11px;\n\tright: -11px;\n\tbackground-color: ", ";\n\tborder-radius: 50%;\n"]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteralLoose(["\n\t\t\tborder-color: ", ";\n\t\t"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteralLoose(["\n\t\t\tbackground-color: ", ";\n\t\t\tborder-color: ", ";\n\t\t\tcolor: ", ";\n\t\t\tcursor: not-allowed;\n\t\t"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteralLoose(["\n\t\t\tbackground-color: ", ";\n\t\t\tborder-color: ", ";\n\t\t\tcolor: ", ";\n\t\t"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteralLoose(["\n\tposition: relative;\n\tcursor: pointer;\n\twidth: 47%;\n\tmargin: 10px;\n\tborder: 2px solid ", ";\n\tpadding: 0 ", ";\n\tbackground-color: ", ";\n\tdisplay: inline-block;\n\tborder-radius: 3px;\n\theight: 70px;\n\tdisplay: flex;\n\tflex-direction: column;\n\tjustify-content: center;\n\ttransition: background-color 100ms ease-out;\n\t", ";\n\n\t", ";\n\n\t", ";\n\n\t@media (max-width: ", ") {\n\t\twidth: 100%;\n\t}\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteralLoose(strings, raw) { if (!raw) { raw = strings.slice(0); } strings.raw = raw; return strings; }

var CopyUser = _styledComponents.default.div(_templateObject(), _colors.default.greyLight, _spacing.default.s4, _colors.default.white, function (props) {
  return props.selected && (0, _styledComponents.css)(_templateObject2(), _colors.default.highlight, _colors.default.primary, _colors.default.textColor);
}, function (props) {
  return props.disabled && (0, _styledComponents.css)(_templateObject3(), _colors.default.disabledBackground, _colors.default.greyLight, _colors.default.grey);
}, function (props) {
  return props.disabled && props.selected && (0, _styledComponents.css)(_templateObject4(), _colors.default.primaryLight);
}, _breakpoints.default.tablet);

CopyUser.displayName = 'CopyUser';

var IconWrapper = _styledComponents.default.div(_templateObject5(), _colors.default.primary);

IconWrapper.displayName = 'IconWrapper';
var FlexTickIcon = (0, _styledComponents.default)(_Tick.default)(_templateObject6());
FlexTickIcon.displayName = 'TickIcon';
var FlexErrorIcon = (0, _styledComponents.default)(_Error.default)(_templateObject7());
FlexErrorIcon.displayName = 'ErrorIcon';

var NameText = _styledComponents.default.span(_templateObject8());

NameText.displayName = 'NameText';

var SubText = _styledComponents.default.span(_templateObject9(), _colors.default.error);

SubText.displayName = 'SubText';

var Item = function Item(_ref) {
  var name = _ref.name,
      selected = _ref.selected,
      warning = _ref.warning,
      _onClick = _ref.onClick,
      disabled = _ref.disabled;
  return _react.default.createElement(CopyUser, {
    onClick: function onClick() {
      if (!disabled) {
        _onClick();
      }
    },
    selected: selected,
    disabled: disabled,
    "data-e2e": "employee-card"
  }, _react.default.createElement(NameText, null, name), warning && _react.default.createElement(SubText, null, warning), selected && _react.default.createElement(IconWrapper, null, warning ? _react.default.createElement(FlexErrorIcon, {
    "aria-label": "Employee has warning",
    size: 11,
    color: _colors.default.white
  }) : _react.default.createElement(FlexTickIcon, {
    "aria-label": "Employee is selected",
    size: 11,
    color: _colors.default.white
  })));
};

Item.displayName = 'Item';
Item.propTypes = {
  name: _propTypes.string,
  selected: _propTypes.bool,
  onClick: _propTypes.func,
  disabled: _propTypes.bool,
  warning: (0, _propTypes.oneOfType)([_propTypes.node, _propTypes.string])
};
Item.defaultProps = {
  name: '',
  selected: false,
  onClick: function onClick() {},
  disabled: false,
  warning: undefined
};
var _default = Item;
exports.default = _default;